import React from 'react'
import { CustomerServiceTelephone } from '@mobi/component-library/Base/Link'
import { MessageStyled } from './ProvideExtraPersonalIdMessage.styles'

export const ProvideExtraPersonalIdMessage = () => {
  return (
    <MessageStyled>
      Please provide additional information such as <strong>Driver's Licence</strong>,{' '}
      <strong>Passport</strong> or call <CustomerServiceTelephone /> for assistance.
    </MessageStyled>
  )
}
